import { connect } from '../../redux/connect';
import Filter from './Filter';
import { setQueryParamsAction } from '../../redux/actions';
import {
  getOxygenMappings,
  getQueryParams,
  getCurrentViewType,
  getActiveUsers,
  getRFIEnum,
} from '../../redux/selectors';
import { toOptionsArray } from '../../utils/parsing-helpers';

const mapStateToProps = (state) => ({
  oxygen: getOxygenMappings(state),
  queryParams: getQueryParams(state),
  viewType: getCurrentViewType(state),
  projectUsers: getActiveUsers(state),
  impactOptions: toOptionsArray(getRFIEnum('scheduleImpact', true)(state)),
  categoryOptions: toOptionsArray(getRFIEnum('category', true)(state)),
  disciplineOptions: toOptionsArray(getRFIEnum('discipline', true)(state)),
  priorityOptions: toOptionsArray(getRFIEnum('priority', true)(state)),
});

const mapDispatchToProps = {
  setQueryParamsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
